import React, { useEffect, useState } from 'react';
import { getCourses } from '../services/api';

const MonitorCourses = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await getCourses();
        setCourses(Array.isArray(data) ? data : data.documents || []);
      } catch (error) {
        console.error('Failed to fetch courses:', error);
      }
    };

    fetchCourses();
  }, []);


  return (
    <div className="p-6">
      <h2 className="text-2xl font-poppins text-driveeasy-blue dark:text-driveeasy-blue2 mb-4">Monitor Courses</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {courses.map((course) => (
          <div key={course.courseId} className="bg-white dark:bg-neutral-800 shadow-md rounded-lg p-4 border dark:border-neutral-600">
            <h3 className="text-lg font-semibold text-driveeasy-blue dark:text-driveeasy-yellow ">{course.title}</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{course.shortDescription}</p>
            <p className="text-sm mt-2 text-gray-700 dark:text-gray-200">
              <strong>Price:</strong> ₹{course.price} &nbsp; | &nbsp;
              <strong>Duration:</strong> {course.duration}
            </p>
            <p className="text-sm mt-1 text-gray-700 dark:text-gray-200"><strong>Rating:</strong> {course.rating} ⭐ ({course.reviews} reviews)</p>
            <div className="mt-3">
              <p className="text-xs text-gray-500 dark:text-gray-400">Course ID: {course.courseId}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonitorCourses;
